import React from 'react';
import { Briefcase, BarChart, CheckCircle, TrendingUp, FileText, DollarSign, ArrowUpRight, ClipboardList, Banknote, FileCheck } from "lucide-react";
import { Link } from 'react-router-dom';

function GeneralTaxation() {
    const services = [
        { icon: <ClipboardList className="w-6 h-6 text-blue-600" />, title: "Monthly Bookkeeping & Data Processing", desc: "Accurate bookkeeping and data entry for smooth financial operations." },
        { icon: <CheckCircle className="w-6 h-6 text-blue-600" />, title: "Payroll Processing", desc: "Efficient and compliant payroll management." },
        { icon: <FileText className="w-6 h-6 text-blue-600" />, title: "Filing HST, WSIB, Payroll, EHT Returns", desc: "Ensure timely tax filings to avoid penalties." },
        { icon: <BarChart className="w-6 h-6 text-blue-600" />, title: "Interim Financial Statements", desc: "Periodic financial statements for better decision-making." },
        { icon: <Banknote className="w-6 h-6 text-blue-600" />, title: "Reconcile Your Bank Account", desc: "Keep your financial records accurate and up-to-date." },
        { icon: <TrendingUp className="w-6 h-6 text-blue-600" />, title: "Generate an Income Statement", desc: "Understand your business's profitability with structured reports." },
        { icon: <FileCheck className="w-6 h-6 text-blue-600" />, title: "Generate a Balance Sheet", desc: "Get a snapshot of your company’s financial position." },
        { icon: <DollarSign className="w-6 h-6 text-blue-600" />, title: "Analyze Your General Ledger", desc: "Identify financial trends and improve business strategies." }
    ];

    return (
        <div className="w-full">
            {/* Hero Section */}
            <section className="relative text-center w-full h-[600px] lg:h-[700px] flex items-center justify-center"
                style={{
                    backgroundImage: "url('images/general.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                }}>
                <div className="absolute inset-0 flex flex-col items-center justify-center bg-black bg-opacity-50 text-white px-6">
                    <h1 className="text-4xl md:text-6xl lg:text-8xl font-bold mb-4">General Taxation</h1>
                    <p className="text-lg md:text-2xl lg:text-3xl max-w-4xl text-gray-400">
                    Streamlining taxation and boosting profitability – your reliable accounting ally!
                    </p>
                </div>
            </section>

            {/* Main Content Section */}
            <div className="bg-slate-900 py-12 px-6 md:px-16">
                <div className="flex flex-wrap items-center justify-center gap-12 max-w-7xl mx-auto">
                    {/* Text Content */}
                    <div className="text-center max-w-3xl lg:max-w-4xl">
                        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-100">
                            Comprehensive Accounting Services
                        </h2>
                        <p className="text-lg md:text-xl text-gray-400 mt-6 text-justify">
    We provide experts For, tax filing, and financial analysis services tailored to your business needs. Our team ensures compliance and financial accuracy, so you can focus on growth and profitability.  
    From managing payroll and reconciling bank accounts to generating financial statements and optimizing tax strategies, we help streamline your financial operations. Let us handle the complexities of taxation while you concentrate on scaling your business with confidence.
</p>

                        <div className="flex mt-6 justify-center">
                            <Link to="/contactus">
                            <button className="flex items-center gap-2 bg-amber-300 text-black p-3 px-6 text-lg font-semibold hover:bg-amber-600 transition">
                                Schedule A Call
                                <ArrowUpRight size={20} />
                            </button></Link>
                        </div>
                    </div>

                    {/* Service Cards Grid */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mt-10 max-w-6xl mx-auto">
                        {services.map((service, index) => (
                            <div key={index} className="bg-white p-6 shadow-md rounded-lg hover:shadow-lg transition-all">
                                <div className="flex items-center space-x-3">
                                    {service.icon}
                                    <h3 className="text-xl font-semibold text-gray-800">{service.title}</h3>
                                </div>
                                <p className="text-gray-600 mt-2">{service.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
export default GeneralTaxation;